import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { Grid, Typography } from '@mui/material'
import Input from 'components/generic/form/Input'

const SettingsDoubleInput = ({ title, subTitle, subTitle2, label1, label2, path1, path2 }) => {
  const { control } = useFormContext()

  return (
    <>
      <Typography variant="h6" color="textPrimary">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {subTitle}
      </Typography>
      {subTitle2 && (
        <Typography variant="body2" color="textSecondary">
          {subTitle2}
        </Typography>
      )}
      <Grid container flexWrap="nowrap" gap={2} mt={2}>
        <Grid item xs={6}>
          <Input name={path1} label={label1} defaultValue="" control={control} multiline />
        </Grid>
        <Grid item xs={6}>
          <Input name={path2} label={label2} defaultValue="" control={control} multiline />
        </Grid>
      </Grid>
    </>
  )
}

SettingsDoubleInput.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  subTitle2: PropTypes.string,
  label1: PropTypes.string,
  label2: PropTypes.string,
  path1: PropTypes.string.isRequired,
  path2: PropTypes.string.isRequired,
}

SettingsDoubleInput.defaultProps = {
  subTitle2: '',
  label1: '',
  label2: '',
}

export default SettingsDoubleInput
